module.exports = __webpack_public_path__ + "static/img/laptop.63e219b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laptop.png
// module id = FCp7
// module chunks = 0